import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { StorageService } from '../../services/storage/storage.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { StateService } from '../../services/common/claim-year.service';
import { MatDialog } from '@angular/material/dialog';
import { commonLabelConstants } from '../../constants/label-constants';
import { CompanyNotificationService } from '../../services/common/companyNotification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  companyList: any[] = [];
  yearList: any[] = [];
  companyId: any;
  DecryptcompanyId: any;
  yearId: any;
  DecryptYearId: any;
  roleId: string | null = null;
  decryptRoleId: any;
  isModalOpen: boolean = false;
  isModelOpenForForm: boolean = false;
  notificationList: Array<{
    tittle: string;
    details: string;
    moduleName: string;
  }> = [];
  public focus: boolean = false;
  labelConstants: any;
  userName: any;
  userId: any;
  userImage: any;
  notificationCount: number = 0;
  EncryptCompanyId: any;
  EncryptYearId: any;
  companyName!: string;
  searchControl: any;
  searchYearControl: any;
  private eventSubscription!: Subscription;
  filteredCompanyList: any[] = [];
  filteredYearList: any[] = [];
  roleName:any;
  currentRoute : any = '';
  headerShowMenuArray : any = ['claim-workflow', 'upload'];

  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly commonService: CommonService,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly apiUrl: ApiUrlHelper,
    private readonly dialog: MatDialog,
    private readonly sharedDataService: StateService,
    private readonly companyNotificationService: CompanyNotificationService,
  ) { }

  ngOnInit() {
    this.DecryptcompanyId = localStorage.getItem('companyId');
    this.DecryptYearId = localStorage.getItem('yearId');
    this.decryptRoleId = this.storageService.getValue('roleId');
    let decryptuserId = this.storageService.getValue('userId');
    this.companyName = this.storageService.getValue('companyName');
    this.companyName = this.companyName == 'null' || this.companyName == 'undefined' ? '' : this.companyName;
    this.companyId = this.commonService.Decrypt(this.DecryptcompanyId) == '' ? null : this.commonService.Decrypt(this.DecryptcompanyId);
    this.yearId = this.commonService.Decrypt(this.DecryptYearId) == '' ? null : this.commonService.Decrypt(this.DecryptYearId);
    this.roleId = this.commonService.Decrypt(this.decryptRoleId) == '' ? null : this.commonService.Decrypt(this.decryptRoleId);
    this.companyNotificationService.companyAdded$.subscribe(() => {
      this.getCompanyList();
    });
    if (this.roleId === '1') {
      this.getCompanyList();
    } else if (this.companyId) {
      this.fetchYearList(this.companyId ? this.companyId : 0);
    }
    // this.fetchNotificationlist(0);
    this.userName = this.storageService.getValue('userName');
    this.userId = this.commonService.Decrypt(decryptuserId);
    this.userImage = this.storageService.getValue('userImage');
    this.labelConstants = commonLabelConstants;
    this.fetchUserDetails();
    this.commonService.getUserImage().subscribe((image) => {
      if (image) {
        this.userImage = image;
        localStorage.setItem('userImage', image);
      }
    });
    this.eventSubscription = this.sharedDataService.triggerEvent$.subscribe(() => {
      this.fetchYearList(this.companyId ? this.companyId : 0);
      setTimeout(() => {
        this.DecryptYearId = localStorage.getItem('yearId');
        this.yearId = this.commonService.Decrypt(this.DecryptYearId) == '' ? null : this.commonService.Decrypt(this.DecryptYearId);
      }, 1000);
    });

    this.eventSubscription = this.sharedDataService.triggerEventCompany$.subscribe(() => {
      this.getCompanyList();
    });
    this.roleName = this.storageService.getValue('userRole');
    this.router.events.subscribe((val) => {
      this.currentRoute =  this.router.url
    });

    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
      this.fetchYearList(this.companyId ? this.companyId : 0);
    });
    this.sharedDataService.yearId$.subscribe((yearId) => {
      this.yearId = yearId;
    });
  }

  getCompanyList() {
    const api = this.apiUrl.apiUrl.Company.GetCompanyListWithoutPagination;
    this.commonService.doGet(api).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.companyList = response.data;
          this.filteredCompanyList = this.companyList;
          if (this.companyId) {
            this.companyId = this.companyList.find(
              (c) => String(c.id) === String(this.companyId)
            )?.id;
            if (this.companyId) this.fetchYearList(this.companyId ? this.companyId : 0);
          }
        }
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }

  fetchYearList(companyId: string) {
    const api = this.apiUrl.apiUrl.Company.GetFinancialYear.replace(
      '{Id}',
      companyId
    );
  
    this.commonService.doGet(api).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.yearList = response.data.map((year: any) => {
            const start = new Date(year.startDate);
            const end = new Date(year.endDate);
  
            const startDateFormatted = `${start.toLocaleString('default', { month: 'short' })}-${start.getFullYear()}`;
            const endDateFormatted = `${end.toLocaleString('default', { month: 'short' })}-${end.getFullYear()}`;
  
            const claimNamePart = year.claimName && year.claimName.trim() !== '' ? ` (${year.claimName})` : '';
  
            year.displayLabel = `${startDateFormatted} to ${endDateFormatted}${claimNamePart}`;
            return year;
          });
  
          this.filteredYearList = this.yearList;
  
          if (this.yearId) {
            this.yearId = this.yearList.find(y => String(y.id) === String(this.yearId))?.id;
          }
        }
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
        console.error('Error fetching year list:', err);
      },
    });
  }
  
  filterCompanies(searchText: string) {
    if (!searchText) {
      this.filteredCompanyList = this.companyList;
    } else {
      const lowerCaseSearchText = searchText.toLowerCase();
      this.filteredCompanyList = this.companyList.filter(company =>
        company.companyName.toLowerCase().includes(lowerCaseSearchText)
      );
    }
  }

  filterYear(searchYearText: string) {
    if (!searchYearText) {
      this.filteredYearList = this.yearList;
    } else {
      const lowerCaseSearchText = searchYearText.toLowerCase();
      this.filteredYearList = this.yearList.filter(company =>
        company.displayLabel.toLowerCase().includes(lowerCaseSearchText)
      );
    }
  }

  onCompanyChange(event: any) {
    this.spinner.show();
    if (event) {
      this.companyId = event.value;
      if (this.companyId)
        this.EncryptCompanyId = this.commonService.Encrypt(this.companyId)
      localStorage.setItem('companyId', this.EncryptCompanyId);
      this.yearId = null;
      
      this.yearList = [];
      localStorage.removeItem('yearId');
      this.sharedDataService.setYearId('');
      this.sharedDataService.setMenuRowData(false);
      if (this.companyId) {
        this.sharedDataService.setCompanyId(this.companyId);
        this.fetchYearList(this.companyId ? this.companyId : 0);
      }
      else{
        this.spinner.hide()
      }

    } else {
      localStorage.removeItem('companyId');
      this.sharedDataService.setCompanyId('');
      this.sharedDataService.setYearId('');
      this.yearId = null

      this.spinner.hide();
    }


  }

  onYearChange(event: any) {
    if (event) {

      if (this.yearId && this.yearId != 0 && this.yearId != "0") {
        this.EncryptYearId = this.commonService.Encrypt(this.yearId)
        localStorage.setItem('yearId', this.EncryptYearId);
        this.sharedDataService.setYearId(this.yearId);
      }
      this.sharedDataService.setMenuRowData(false);
    } else {
      localStorage.removeItem('yearId');
      this.sharedDataService.setYearId('');
    }
  }

  handleImageError() {
    this.userImage = '../../../assets/img/default-user-profile.svg';
  }

  // fetchNotificationlist(IsRead: number) {
  //   this.spinner.show();
  //   let api = this.apiUrl.apiUrl.Notification.GetNotificationList;
  //   this.commonService.doPost(api, { IsRead }).subscribe({
  //     next: (response: any) => {
  //       if (response?.data.length > 0) {
  //         this.notificationCount = response.data[0].notificationCount;
  //         this.notificationList = response.data;
  //         this.spinner.hide();
  //       }
  //     },
  //     error: (error: any) => {
  //       this.spinner.hide();
  //       console.log(error);

  //     },
  //     complete: () => {
  //       this.spinner.hide();
  //     },
  //   });
  // }

  logOut(action: any) {
    let apiUrl = ''
    if (localStorage.getItem('authToken') != null) {
      apiUrl = this.apiUrl.apiUrl.Login.logout;
    }
    else {
      this.router.navigate(['/login']);
      localStorage.clear();
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: { action },
      disableClose: true,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.spinner.show();
        this.commonService
          .doPost(apiUrl, this.userId)
          .pipe()
          .subscribe({
            next: (response) => {
              if (response.success) {
                this.router.navigate(['/login']);
                localStorage.clear();
                this.spinner.hide();
              } else {
                this.toastr.error(response.message);
                this.spinner.hide();
              }
            },
            error: (err) => {
              this.spinner.hide();
            },
          });
      }
    });
  }

  navigateToProfile() {
    this.router.navigate(['/myaccount']);
  }

  toggleModal(IsRead: number) {
    this.isModalOpen = !this.isModalOpen;
    if (this.isModalOpen) {
      // this.fetchNotificationlist(IsRead);
    }
  }

  toggleModalForForms() {
    this.isModelOpenForForm = !this.isModelOpenForForm;
  }

  handleModalClose() {
    // this.fetchNotificationlist(0);
  }

  handleClearAll() {
    // this.fetchNotificationlist(2);
  }

  fetchUserDetails() {
    this.spinner.show();
    const api = this.apiUrl.apiUrl.User.GetUserById.replace(
      '{Id}',
      this.userId
    );
    this.commonService
      .doGet(api)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.userName =
              response.data.firstName + ' ' + response.data.lastName;
          } else {
            this.spinner.hide();
            this.toastr.error(response.message);
          }
        },
        error: (error) => {
          this.spinner.hide();
          console.log(error);

        },
      });
  }

  resetCompanyFilter(){
    let isSuperAdmin = this.roleName === 'Super Admin' ? true : false;
    if(isSuperAdmin){
      localStorage.removeItem('yearId');
      localStorage.removeItem('companyId');
      this.sharedDataService.setCompanyId('');
      this.sharedDataService.setYearId('');
      this.companyId = null;
      this.yearId = null;
      this.filteredYearList = [];
  }
  else{
      this.sharedDataService.setYearId('');
      this.yearId = null;
    }
  }
}
